import React from "react";
import PropTypes from "prop-types";
import { IframeResizer } from "../../utils/iframeResizer";

const WeddingFullForm = ({ config }) => {
	const renderedComponent = config.iframeUrl.length > 0 && (
		<iframe
			className="fa-iframe"
			src={config.iframeUrl}
			frameBorder="0"
			height="0"
			width="100%"
			title={config?.title}
			onLoad={() => {
				// Checking if it is an iframe
				if (window.self !== window.top) {
					// Temporarily hide the iframe contents
					document.getElementsByTagName("html")[0].style.visibility = "hidden";

					// Break out of the iframe
					window.parent.location.href = document.location.href;
				} else {
					IframeResizer(window);
				}
			}}
		/>
	);

	return renderedComponent;
};

WeddingFullForm.propTypes = {
	config: PropTypes.shape({
		iframeUrl: PropTypes.string,
		title: PropTypes.string,
		type: PropTypes.string,
	}).isRequired,
};

export default WeddingFullForm;
export { WeddingFullForm };
